import React from 'react';
import moment from 'moment';
import PageVisibility from 'react-page-visibility';

let DEFAULT_POLL_INTERVAL = 30000;
const MINIMUM_POLL_INTERVAL = 5000;

if (window.location.href.indexOf('localhost:8080') > -1) {
  console.log(
    '%cLocal Environment Detected - Data Poller Default Set to 3 minutes',
    'background: #12d125; color: #ffffff; padding: 3px',
  );
  DEFAULT_POLL_INTERVAL = 180000;
}

export default class DataPoller extends React.Component {
  constructor(props) {
    super();
    this.state = {
      hidden: false,
    };
  }

  poll() {
    this.setState({ lastPoll: moment() }, () => {
      this.props.action();
    });
  }

  componentDidMount() {
    this.poll();
    this.pollInterval = setInterval(
      () => this.poll(),
      this.props.frequency || DEFAULT_POLL_INTERVAL,
    );
  }

  componentWillUnmount() {
    clearInterval(this.pollInterval);
  }

  handleVisibilityChange(visibilityState, hidden) {
    this.setState({ hidden }, () => {
      clearInterval(this.pollInterval);
      if (!hidden) {
        this.props.action();
        this.pollInterval = setInterval(
          () => this.poll(),
          this.props.frequency || DEFAULT_POLL_INTERVAL,
        );
      }
    });
  }

  render() {
    return (
      <PageVisibility
        onChange={(state, hidden) => this.handleVisibilityChange(state, hidden)}
      />
    );
  }
}
